import { projectDataType } from ".";

const theInternetData: projectDataType = {
  path: "theinternet",
  title: "The Internet",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965390/Art-Site/TheInternet/-get_-put-7-fixed_b9h0pc.jpg",
  description:
    "Sculpture installation using mechanical mixed media parts and 3D animation projection.",
  year: 2012,
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965390/Art-Site/TheInternet/-get_-put-7-fixed_b9h0pc.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965389/Art-Site/TheInternet/-get_-put-3-fixed_pk1zyl.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965389/Art-Site/TheInternet/-get_-put-20-fixed_dxvr86.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965389/Art-Site/TheInternet/-get_-put-16-fixed_obgg5c.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965389/Art-Site/TheInternet/-get_-put-4-fixes_fjrxfu.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965389/Art-Site/TheInternet/-get_-put-fixed_fvxgrs.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965389/Art-Site/TheInternet/-get_-put-19-fixed_grstl6.jpg",
  ],
};

export default theInternetData;
